module.exports = __webpack_public_path__ + "img/4-1-north-2.5887073a.jpg";